import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceHero = ({ service, onActionClick }) => {
  return (
    <div className="bg-card rounded-xl shadow-md border border-border overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <div className="relative h-64 md:h-80 lg:h-full min-h-[400px]">
          <Image
            src={service?.image}
            alt={service?.imageAlt}
            className="w-full h-full object-cover"
          />
          <div className="absolute top-4 left-4 flex flex-wrap gap-2">
            {service?.badges?.map((badge, index) => (
              <span
                key={index}
                className="px-3 py-1 rounded-full text-xs font-semibold bg-accent text-accent-foreground shadow-md"
              >
                {badge}
              </span>
            ))}
          </div>
        </div>

        <div className="p-6 md:p-8 lg:p-10 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
              <Icon name="Folder" size={16} />
              <span>{service?.category}</span>
              <Icon name="ChevronRight" size={14} />
              <span>{service?.subCategory}</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
              {service?.name}
            </h1>

            <p className="text-base md:text-lg text-muted-foreground mb-6 leading-relaxed">
              {service?.description}
            </p>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Clock" size={20} className="text-primary" />
                </div>
                <div>
                  <div className="text-xs text-muted-foreground caption">Timeline</div>
                  <div className="text-sm font-semibold text-foreground">{service?.timeline}</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="DollarSign" size={20} className="text-secondary" />
                </div>
                <div>
                  <div className="text-xs text-muted-foreground caption">Price Range</div>
                  <div className="text-sm font-semibold text-foreground">{service?.priceRange}</div>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-4 mb-6">
              <div className="flex items-center gap-1">
                {[...Array(5)]?.map((_, i) => (
                  <Icon
                    key={i}
                    name="Star"
                    size={18}
                    className={i < Math.floor(service?.rating) ? 'text-accent fill-accent' : 'text-muted'}
                  />
                ))}
              </div>
              <span className="text-sm font-semibold text-foreground">{service?.rating}</span>
              <span className="text-sm text-muted-foreground">({service?.reviewCount} reviews)</span>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <Button
              variant="default"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              onClick={() => onActionClick('call')}
              className="w-full"
            >
              Call
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="MessageCircle"
              iconPosition="left"
              onClick={() => onActionClick('whatsapp')}
              className="w-full"
            >
              WhatsApp
            </Button>
            <Button
              variant="secondary"
              size="lg"
              iconName="Mail"
              iconPosition="left"
              onClick={() => onActionClick('enquiry')}
              className="w-full"
            >
              Enquire
            </Button>
            <Button
              variant="success"
              size="lg"
              iconName="UserPlus"
              iconPosition="left"
              onClick={() => onActionClick('assign')}
              className="w-full"
            >
              Assign
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHero;